import { Link } from '@inertiajs/react';

import { LawyerCardH } from '@/Components/LawyerCardH';
import { SectionHeader } from '@/Components/SectionHeader';
import { PublicLayout } from '@/Layouts/PublicLayout';
import { toCardData, type ServerLawyerCard } from '@/Support/toCardData';

type Props = {
    caseNumber: string | null;
    matches: ServerLawyerCard[];
};

export default function GetMatchedThanks({ caseNumber, matches }: Props) {
    return (
        <PublicLayout active="get-matched">
            <section className="bg-paper border-b border-rule">
                <div className="max-w-3xl mx-auto px-6 py-12">
                    <div className="text-[12px] uppercase tracking-widest text-ember mb-3">
                        Thanks
                    </div>
                    <h1 className="text-[40px] md:text-[48px] leading-tight text-ink">
                        We&apos;re reaching out to attorneys for you.
                    </h1>
                    {caseNumber !== null && (
                        <p className="text-ink-soft mt-3 max-w-xl">
                            Save your case number — <strong className="text-ink">{caseNumber}</strong>. We&apos;ll
                            confirm by email shortly.
                        </p>
                    )}
                </div>
            </section>

            <div className="max-w-3xl mx-auto px-6 py-10">
                <SectionHeader title={matches.length > 0 ? 'Matched attorneys' : 'Still searching'} />

                {matches.length === 0 ? (
                    <p className="text-ink-soft mt-4">
                        We didn&apos;t find a published attorney in your area accepting clients right now. A
                        team member will review your case manually within one business day.
                    </p>
                ) : (
                    <div className="space-y-4 mt-4">
                        {matches.map((m) => (
                            <LawyerCardH key={m.id} data={toCardData(m)} profileHref={`/${m.slug}`} />
                        ))}
                    </div>
                )}

                <p className="mt-8 text-[14px] text-ink-soft">
                    Not the right fit? <Link href="/get-matched" className="text-ember underline">Submit a new
                    case</Link>.
                </p>
            </div>
        </PublicLayout>
    );
}
